import { PayloadAction } from '../../../store.model';
import { scorePercentage } from '../../form/function/score-percentage.function';
import { INITIAL_MAX_ROWS } from '../fixture/initial-max-rows';
import { createNextGridState } from '../function/create-next-grid-state.function';
import { sortRows } from '../function/sort-rows.function';
import { ActionType } from '../landing.action';
import { LandingState } from '../landing.state';
import { ForMyTeamGridOptions } from '../model/for-my-team-grid-options.model';
import { GridType } from '../model/grid-type.model';

import {
    ChangeDateRange,
    ChangeDateRangeResult,
} from './change-date-range.action';

export function changeDateRangeReducer(
    state: LandingState,
    _: PayloadAction<
        ActionType.EVAL_LANDING__CHANGE_DATE_RANGE,
        ChangeDateRange
    >,
): LandingState {
    return {
        ...state,
        pending: {
            ...state.pending,
        },
    };
}

export function changeDateRangeResultReducer(
    state: LandingState,
    action: PayloadAction<
        ActionType.EVAL_LANDING__CHANGE_DATE_RANGE_RESULT,
        ChangeDateRangeResult
    >,
): LandingState {
    const nextState: LandingState = {
        ...state,
        pending: {
            ...state.pending,
        },
    };

    try {
        action.payload.result?.forEach((e) => {
            e.eventDate = e.eventDate == null ? null : new Date(e.eventDate);
            e.evaluationDate =
                e.evaluationDate == null ? null : new Date(e.evaluationDate);
            (e as any).percentage = scorePercentage(e.score, e.maxScore);
        });

        const ngo = createNextGridState(action.payload.type, state, nextState);

        let nextFilteredRows = sortRows(action.payload.result, ngo.sortOptions);
        ngo.showAllEnabled = nextFilteredRows.length > INITIAL_MAX_ROWS;
        nextFilteredRows = nextFilteredRows.slice(
            0,
            ngo.showAll ? action.payload.result.length : INITIAL_MAX_ROWS,
        );

        ngo.days = action.payload.days;
        ngo.rows = action.payload.result;
        ngo.filteredRows = nextFilteredRows;
        ngo.selectedFilterOptions = null;

        if (ngo.type === GridType.FOR_MY_TEAM) {
            const o = ngo as ForMyTeamGridOptions;
            o.teamAlt = action.payload.teamAlt ?? o.teamAlt;
        }

        return nextState;
    } catch {
        switch (action.payload.type) {
            case GridType.FOR_ME:
                nextState.forMe = {
                    ...state.forMe,
                    rows: null,
                };
                break;
            case GridType.BY_ME:
                nextState.byMe = {
                    ...state.byMe,
                    rows: null,
                };
                break;
            case GridType.FOR_MY_TEAM:
                nextState.forMyTeam = {
                    ...state.forMyTeam,
                    rows: null,
                };
                break;
        }

        return nextState;
    }
}
